import type * as lazyIndex from './lazyIndex';
import type { CopilotCommandCenterProps } from './components/CopilotCommandCenter';
import {
    type LazyComponent,
    LazyModule,
    createLazyComponent,
    registerLazyOrchestrator,
} from 'owa-bundling';
import { CopilotCommandCenterPlaceholder } from './components/CopilotCommandCenterPlaceholder';
import { onAcquisitionsRefreshed } from 'owa-m365-acquisitions/lib/lazyFunction';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotCommandCenter" */ './lazyIndex'),
    { name: 'CopilotCommandCenter' }
);

export const CopilotCommandCenter: LazyComponent<CopilotCommandCenterProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotCommandCenter, CopilotCommandCenterPlaceholder);

registerLazyOrchestrator(
    onAcquisitionsRefreshed,
    lazyModule,
    m => m.onAcquisitionsRefreshedOrchestrator
);
